import { CompanySettingsViews, QueryParamDataType, WorkspaceSettingsViews } from '../constants';
import { CustomerNotificationEvents } from '../../../../helpers/customerNotificationEvents';

export enum RequiredQueryParams {
  VIEW = 'view',
}

export enum BillingQueryParams {
  SESSION_ID = 'session_id',
  CHECKOUT = 'checkout',
  SMS = 'sms',
}

export enum WorkspaceSettingsQueryParams {
  SETTINGS = 'settings',
}

export enum ShopifyQueryParams {
  SHOPIFY = 'shopify',
}

export enum CustomerNotificationsQueryParams {
  TEMPLATE = 'template',
}

export const SettingsQueryParams = {
  ...RequiredQueryParams,
  ...BillingQueryParams,
  ...WorkspaceSettingsQueryParams,
  ...ShopifyQueryParams,
  ...CustomerNotificationsQueryParams,
};

const SettingsPageQueryParams = {
  [SettingsQueryParams.VIEW]: {
    required: true,
    type: QueryParamDataType.CUSTOM,
    acceptedValues: CompanySettingsViews,
    default: CompanySettingsViews.GENERAL,
  },
  [SettingsQueryParams.CHECKOUT]: {
    required: false,
    type: QueryParamDataType.BOOLEAN,
  },
  [SettingsQueryParams.SMS]: {
    required: false,
    type: QueryParamDataType.BOOLEAN,
  },
  [SettingsQueryParams.SESSION_ID]: {
    required: false,
    type: QueryParamDataType.STRING,
  },
  [SettingsQueryParams.SETTINGS]: {
    required: false,
    type: QueryParamDataType.CUSTOM,
    acceptedValues: WorkspaceSettingsViews,
  },
  [SettingsQueryParams.SHOPIFY]: {
    required: false,
    type: QueryParamDataType.STRING,
  },
  [SettingsQueryParams.TEMPLATE]: {
    required: false,
    type: QueryParamDataType.CUSTOM,
    acceptedValues: CustomerNotificationEvents,
  },
};

export default SettingsPageQueryParams;
